import React from 'react';
import Grid from 'components/Custom/Grid';
import { getCommunicationEvents } from 'utils/CommunicationEventUtils';
import CommunicationEvent from 'classes/CommunicationEvent';
import { useAppContext } from 'hooks/useAppContext';

export default function CommunicationEventGrid() {
  const columns = CommunicationEvent.columns;
  const { selectedProject } = useAppContext();

  return (
    <Grid
      columns={columns}
      title="Communication Event"
      getRecords={getCommunicationEvents}
      selectedProject={selectedProject}
      component="Inspections"
      enable={{ update: false, delete: false }}
      inspectionColumnTitle="Inspection #"
      options={{
        pageSizeOptions: [10, 15, 25],
        pageSize: 10
      }}
    />
  );
}
